// colori.ts — il colore primario scelto da ognuno (v021, idea del proprietario: come il «colore principale» di Windows
// o Outlook, al posto dei temi). Cambia pulsanti, titoli colorati, icone e il cerchio dietro l'avatar. Tutti i colori
// sono chiari sul fondo viola scuro e con il testo scuro sopra (contrasto ≥ 7:1 con #0E0A24, vedi colori.test.ts).
import { leggiPreferenza, salvaPreferenza } from "../servizi/preferenze.ts";
import { PREFERENZE } from "../costanti.ts";

export { COLORI_PRIMARI, COLORE_PREDEFINITO, eIdColore, type IdColore } from "./paletta.ts";
import { COLORI_PRIMARI, COLORE_PREDEFINITO, eIdColore, type IdColore } from "./paletta.ts";

function rgb(hex: string): string {
  const n = parseInt(hex.slice(1), 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

/** Il colore salvato sul telefono (o il predefinito). */
export function coloreSalvato(): IdColore {
  const c = leggiPreferenza(PREFERENZE.colore);
  return eIdColore(c) ? c : COLORE_PREDEFINITO;
}

/** Mette il colore sulla radice: variabili della grafica (--ld-primario) e del tema (--c-primario). */
export function applicaColore(id: IdColore = coloreSalvato()): void {
  const c = COLORI_PRIMARI.find((x) => x.id === id) ?? COLORI_PRIMARI[0];
  const r = document.documentElement.style;
  r.setProperty("--ld-primario", c.hex);
  r.setProperty("--ld-primario-rgb", rgb(c.hex));
  r.setProperty("--c-primario", c.hex);
  r.setProperty("--c-su-primario", "#0E0A24");
}

export function salvaColore(id: IdColore): void {
  salvaPreferenza(PREFERENZE.colore, id);
  applicaColore(id);
}
